import request from '@/util/bpmRequest'

/**
 * 分页获取列表
 */
export function listPage(params) {
  return request({
    url: '/procModel/listPage',
    method: 'post',
    params
  })
}
/**
 * 流程定义转成流程模型
 */
export function convertToModel(params) {
  return request({
    url: '/procModel/convert-to-model',
    method: 'post',
    params
  })
}

/**
 * 部署流程
 */
export function deploy(params) {
  return request({
    url: '/procModel/deploy',
    method: 'post',
    params
  })
}

/**
 * 删除模型
 */
export function deleteById(params) {
  return request({
    url: '/procModel/deleteById',
    method: 'post',
    params
  })
}

/**
 * 获取模型
 */
export function getModel(params) {
  return request({
    url: '/procModel/getModel',
    method: 'get',
    params
  })
}

/**
 * 保存
 */
export function save(data) {
  return request({
    url: '/procModel/save',
    method: 'post',
    data
  })
}

/**
 * 创建流程模型
 */
export function create(params) {
  return request({
    url: '/procModel/create',
    method: 'post',
    params
  })
}


/**
 * 获取流程实例模型
 */
export function getProcInstModel(id) {
  return request({
    url: '/procModel/getProcInstModel?procInstId='+id,
    method: 'get',
  })
}

